<template>
    <nav class="inline-nav" :id="navId" :aria-label="label" role="navigation">
      <ul role="menubar">
              <li :class="{active: activeTab===idx}" v-for="(key, idx) in tabs" :key="'nav-'+idx"><button :data-tabindex="idx" @click="updateTab">{{key}}</button></li>
      </ul>
    </nav>
</template>

<script>
export default {
  name: "InlineNavigation",
  props: {
    navId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    },
    activeTab: Number,
    change: Function
  },
  data() {
    return {
      offsetLeft: 0
    };
  },
  methods: {
    updateTab(e) {
      if (this.change !== undefined) {
        this.change(parseInt(e.target.dataset["tabindex"]));
      }
    }
  }
};
</script>

<style>
nav.inline-nav {
  display: block;
  position: relative;
  overflow: hidden;
}

nav.inline-nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
}

nav.inline-nav ul li {
  display: inline-block;
}

nav.inline-nav ul {
  display: flex;
  flex-direction: row;
  max-width: 100%;
}
@media(min-width: 1700px){
  nav.inline-nav ul{
  justify-content: flex-end;
  }
}

nav.inline-nav ul li button {
  border: none;
  background: #fff;
  font-size: 1em;
  cursor: pointer;
  color: #9e9e9e;
  white-space: nowrap;
  transition: all .3s ease-in-out;
}

nav.inline-nav ul li.active button {
  color: #4a4f62;
  font-weight: 500;
}

nav.inline-nav ul li button:hover{
  color: #4a4f62;
}
</style>


// WEBPACK FOOTER //
// src/components/InlineNavigation.vue